export const useExport = () => {
  const exportToJson = (
    valueToExport: unknown,
    rootKey?: string,
    options?: { fileName?: string },
  ): void => {
    const now = new Date()
    const pad = (n: number) => String(n).padStart(2, '0')
    const defaultFileName = `intents-export-${pad(now.getDate())}-${pad(
      now.getMonth() + 1,
    )}-${String(now.getFullYear())}-${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(
      now.getSeconds(),
    )}.json`

    const fileName = options?.fileName ?? defaultFileName

    const data = rootKey ? { [rootKey]: valueToExport } : valueToExport

    const json = JSON.stringify(data, null, 2)
    const blob = new Blob([json], { type: 'application/json' })
    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
    URL.revokeObjectURL(url)
  }

  return {
    exportToJson,
  }
}
